<template>
  <sn-modal
    v-model="showModal"
    title="Still working?"
    type="decision"
    primary-text="Sign out"
    secondary-text="Continue working"
    @submit="logout"
    @secondarySubmit="extendSession"
  >
    <div>{{ bodyText }}</div>
    <div class="mt-6">
      <strong>{{ timeRemainingText }}</strong> minutes left
    </div>
  </sn-modal>
</template>

<script>
import { mapMutations } from 'vuex'
import cookie from 'js-cookie'
import { extendSsoSession, expireSso } from '../graphql/signing_room_queries.gql'

export default {
  name: 'SrSessionTimeoutModal',
  props: {
    display: {
      type: Boolean,
      required: true,
      default: false
    },
    totalSeconds: {
      type: Number,
      required: false,
      default: 5 * 60
    }
  },

  data () {
    return {
      showModal: null,
      secondsRemaining: null,
      timerInterval: null
    }
  },

  computed: {
    timeRemainingText () {
      const secs = this.secondsRemaining % 60
      const minutes = Math.floor(this.secondsRemaining / 60)
      return minutes + ':' + `${secs < 10 ? '0' + secs : secs}`
    },
    isPortal () {
      return this.$route.path.includes('/portal')
    },
    isLoggedOut () {
      return this.$route.path.includes('/portal/logged_out')
    },
    bodyText () {
      if (this.isPortal) {
        return 'Sign out happens automatically after 15 minutes. This helps ensure your information remains secure.'
      }
      return 'Sign out happens automatically after being idle for 15 minutes. This helps ensure your information remains secure.'
    }
  },

  watch: {
    display (newVal) {
      this.showModal = newVal && !this.isLoggedOut
      if (newVal) {
        this.secondsRemaining = this.totalSeconds
        this.timerInterval = setInterval(() => {
          if (this.display && this.secondsRemaining > 0) {
            this.secondsRemaining -= 1
          } else if (this.display) {
            this.logout()
          }
        }, 1000)
      } else {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },
    totalSeconds (newVal) {
      if (newVal) {
        this.secondsRemaining = newVal
      } else {
        this.secondsRemaining = 5 * 60
      }
    }
  },

  created () {
    this.showModal = this.display
  },

  methods: {
    ...mapMutations(['resetAppTimeout']),
    extendSession () {
      if (this.isPortal) {
        this.$apollo.mutate({
          mutation: extendSsoSession,
          variables: {
            signerGuid: cookie.get('srm_signer_guid')
          }
        })
      }
      this.resetAppTimeout()
      this.$emit('extend')
    },
    logout () {
      clearInterval(this.timerInterval)
      if (this.isPortal) {
        this.$router.push('/portal/logged_out')
        this.closePortal()
      } else {
        sessionStorage.clear()
        window.location.assign('/logout')
      }
    },
    closePortal () {
      this.$apollo.mutate({
        mutation: expireSso
      }).then(({ data }) => {
        this.showModal = false
        if (data.expireSso.error) {
          console.error(data.expireSso.error)
        }
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
